<template>
    <div>
        <v-menu
            offset-y
            min-width="auto"
            v-model="menu"
            :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    outlined
                    hide-details
                    readonly
                    clearable
                    append-icon="date_range"
                    :value="dateRangeText"
                    :height="height"
                    :placeholder="$t('placeholder.dateRange')"
                    :style="{
                        minWidth: '280px'
                    }"
                    v-on="on"
                    v-bind="attrs"
                    @click:clear="onDateRangeClear"/>
            </template>

            <v-date-picker
                no-title
                range
                scrollable
                v-model="dateRange"
                :color="color"/>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'DateRangeField',

    props: {
        value: {
            type: Array,
            default: () => []
        },

        color: {
            type: String,
            default: 'primary'
        },

        height: {
            type: String,
            default: '40px'
        }
    },

    data () {
        return {
            menu: false
        }
    },

    computed: {
        dateRange: {
            get () {
                return this.value
            },

            set (value) {
                this.$emit('input', value)
                if (value.length === 2) {
                    this.menu = false
                    this.$emit('change', value)
                }
            }
        },

        dateRangeText () {
            if (this.value.length === 0) {
                return ''
            }

            let fromDate = this.value?.[0] ?? ''
            let toDate = this.value?.[1] ?? ''

            if (fromDate !== '') {
                fromDate = this.$util.getDDMMYYYYDateFormat(new Date(fromDate))
            }

            if (toDate !== '') {
                toDate = this.$util.getDDMMYYYYDateFormat(new Date(toDate))
            }

            return `${fromDate} ~ ${toDate}`
        }
    },

    methods: {
        onDateRangeClear () {
            this.$emit('input', [])
            this.$emit('change', this.dateRange)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
